import {Switch, Route, Redirect, useLocation} from 'react-router-dom';
import cn from 'classnames';

import TopBar from 'components/TopBar';

import DeliveryPlanner from 'pages/DeliveryPlanner';
import Deliveries from 'pages/Deliveries';
import Settings from 'pages/Settings';
import RequestDetails from 'pages/RequestDetails';
import Requests from 'pages/Requests';
import EmployeeForm from 'pages/EmployeeForm';
import VehicleForm from 'pages/VehicleForm';
import UserDetails from 'pages/UserDetails';
import UserForm from 'pages/UserForm';
import Routes from 'pages/Routes';

import {CustomRouteProps} from 'types/ui';
import Products from 'pages/Products';
import {Toaster} from 'react-hot-toast';
import RouteHistory from 'pages/RouteHistory';
import Transactions from 'pages/Transactions';
import TransactionDetails from 'pages/TransactionDetails';
import CompanyDetails from 'pages/CompanyDetails/CompanyDetails';
import ProfileDetails from 'pages/ProfileDetails';
import Members from 'pages/Members/Members';
import Onboarding from 'pages/Onboarding/Onboarding';
import useAuth from 'hooks/useAuth';
import Website from 'pages/Website';
import {Fragment} from 'react/jsx-runtime';

const mainRoutes: CustomRouteProps[] = [
  {path: '/onboarding', component: Onboarding, exact: true},

  {
    path: '/deliveries/delivery_planner',
    component: DeliveryPlanner,
    route: 'dispatch',
  },
  {path: '/deliveries', component: Deliveries, route: 'dispatch'},
  {path: '/products/page/:page', component: Products},
  {path: '/products', component: Products, route: 'offerings'},
  {
    path: '/people/employees/new',
    component: () => <EmployeeForm />,
    route: 'staff',
  },
  {
    path: '/people/employees/:employeeId',
    component: () => <EmployeeForm />,
    route: 'staff',
  },
  {
    path: '/people/teams/new',
    component: () => <VehicleForm />,
    route: 'onsite_workers',
  },
  {
    path: '/people/teams/:vehicleId',
    component: () => <VehicleForm />,
    route: 'onsite_workers',
  },
  {
    path: '/people/customers/:userId/edit',
    component: UserForm,
    route: 'customers',
  },
  {
    path: '/people/customers/:userId',
    component: UserDetails,
    route: 'customers',
  },
  {path: '/people', component: Members, route: 'customers'},
  {path: '/settings', component: Settings, route: 'settings'},
  {
    path: '/settings/company',
    component: CompanyDetails,
    exact: true,
    route: 'company',
  },
  {path: '/details', component: ProfileDetails, exact: true},
  {
    path: '/orders/:id',
    component: RequestDetails,
    exact: true,
    route: 'orderDetails',
  },
  {path: '/requests/:id', component: RequestDetails, exact: true},
  {path: '/transactions/:id', component: TransactionDetails, exact: true},

  {
    path: '/orders/page/:page',
    component: () => <Requests source="micromerchant" />,
    exact: true,
    route: 'orders',
  },

  {
    path: '/transactions',
    component: Transactions,
    exact: true,
    route: 'transactions',
  },
  {
    path: '/transactions/page/:page',
    component: Transactions,
    exact: true,
    route: 'transactions',
  },
  {
    path: '/orders',
    component: () => <Requests source="micromerchant" />,
    exact: true,
    route: 'orders',
  },
  {
    path: '/history/routes/page/:page',
    component: Routes,
    exact: true,
    route: 'dispatch',
  },
  {
    path: '/history/routes/:id',
    component: RouteHistory,
    exact: true,
    route: 'dispatch',
  },
  {path: '/website', component: Website, route: 'website'},
];

function MainApp() {
  const {pathname} = useLocation();
  const {currentUser, rolePermission} = useAuth();
  return (
    <Fragment>
      <TopBar />
      <div className={'content'}>
        <div
          className={cn('content-inside', {
            '--fullsize':
              pathname.startsWith('/deliveries') ||
              pathname.startsWith('/history/routes'),
            '--no-border':
              pathname.startsWith('/history/routes') &&
              !pathname.startsWith('/history/routes/page/1'),
          })}
        >
          <Switch>
            {mainRoutes
              .filter((item) => {
                const permission = rolePermission[item.route as string];

                if (!!permission) {
                  return permission.permissions.read;
                }
                return true;
              })
              .map((route) => {
                // After navigating with Link component to the same page again, the state is persisted.
                // So we need to re-mount the page for the fresh state
                // This is only for RequestDetails page
                return (
                  <Route
                    key={
                      route?.route === 'orderDetails'
                        ? pathname + currentUser?.id
                        : route.path
                    }
                    {...route}
                  />
                );
              })}

            <Redirect
              to={
                currentUser?.is_onboarded
                  ? '/deliveries/delivery_planner'
                  : '/onboarding'
              }
            />
          </Switch>
        </div>
        <Toaster />
      </div>
    </Fragment>
  );
}

export default MainApp;
